import Vue from 'vue'
import TileTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/TakeoffRelation/Grid'
import { formatCurrency } from '@/services/convert'

export default {
  components: {
    'tile-takeoff': TileTakeoff,
  },
  props: ['costDetails', 'sequence', 'levels'],
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      height: '30rem',
      list: this.levels,
      formatCurrency: formatCurrency,
      visible: false,
      width: '110rem',
      padding: '0px',
    }
  },
  beforeMount() {
    this.visible = true
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  created() {
    this.loadingConfig()
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          width: 100,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dynamicTable' },
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          editable: false,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: { type: 'dynamicTable' },
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          editable: false,
          resizable: true,
          headerClass: 'header-right',
          cellRendererParams: { type: 'dynamicTable' },
        },
      ]
    },

    handleCancel() {
      this.visible = false
      this.$emit('closeRelation')
    },

    calculateLevelTotal(item) {
      let levelTotal = 0
      const takeoffs = item.tiles
        .filter(i => i.takeoffs.length > 0)
        .map(i => i.takeoffs)

      takeoffs.forEach(element => {
        levelTotal += element
          .filter(i => i.childTileId === this.costDetails.id)
          .reduce((total, takeoff) => {
            return total + (takeoff.unitCost || 0)
          }, 0)
      })
      return levelTotal
    },

    checkItemCount(item) {
      let itemCount = 0
      const takeoffs = item.tiles
        .filter(i => i.takeoffs.length > 0)
        .map(i => i.takeoffs)

      takeoffs.forEach(element => {
        const takeoffs = element.filter(
          i => i.childTileId === this.costDetails.id,
        )
        if (takeoffs.length > 0) {
          itemCount++
        }
      })
      return itemCount
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },
  },
}
